var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[(_vm.rssi)?_c('icon',{attrs:{"icon":_vm.signalIcon,"width":"20"}}):_vm._e(),(_vm.rssi)?_c('span',{staticStyle:{"font-size":"10px"}},[_vm._v(_vm._s(Math.floor(_vm.rssi)))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }